import React, { useState } from 'react';
import { subscribeNewsletter } from '../lib/dataService';
import { toast } from 'sonner';
import { Mail, Send } from 'lucide-react';

export default function NewsletterSignup({ compact = false }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error('Please enter your email address.'); return; }
    setSending(true);
    try {
      const res = await subscribeNewsletter({ email, name });
      toast.success(res.message);
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Subscription failed. Please try again.');
    }
    setSending(false);
  };

  if (compact) {
    return done ? (
      <p className="newsletter-done-compact">You're subscribed! Watch your inbox for new stories.</p>
    ) : (
      <form className="newsletter-compact" onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          aria-label="Email address"
        />
        <button type="submit" disabled={sending} aria-label="Subscribe">
          <Send size={15} />
        </button>
      </form>
    );
  }

  return (
    <section className="newsletter-band">
      <div className="container newsletter-inner">
        <div className="newsletter-text">
          <div className="newsletter-icon"><Mail size={26} /></div>
          <div>
            <h2>Never Miss a Story</h2>
            <p>Join our newsletter and get notified every time a new story is posted — game results, national team news and league updates straight to your inbox.</p>
          </div>
        </div>
        {done ? (
          <div className="newsletter-done">
            <h3>You're on the list!</h3>
            <p>We'll email you whenever a new story goes live.</p>
          </div>
        ) : (
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name (optional)"
              aria-label="Name"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              aria-label="Email address"
              required
            />
            <button type="submit" className="btn-primary" disabled={sending}>
              {sending ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
